<div class="p-1 mt-2">
  <p class="title">{{ 'dialog.ai-match-check.title' | translate: lang }}</p>
  <div class="info">
    <p>{{ 'dialog.ai-match-check.info' | translate: lang }}</p>
  </div>
  <div class="d-flex justify-content-end">
    <broker-button
      [id]="'cancel'"
      [height]="'large'"
      [width]="'compact'"
      [icon]="'arrow'"
      [iconPosition]="'right'"
      (clickEvent)="cancelEvent.emit()"
    >
      {{ 'dialog.ai-match-check.cancel-button' | translate: lang }}
    </broker-button>
  </div>
</div>
